export default `
  sys {
    id
  }
`
